import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { listRowCellBridgeStyles } from '../list.row.cell.theme';

const tokens = DesignSystem.tokens;
export const listRowV2StyleId = 'wb-v2-list-row-v2-theme';

/**
 * Token bridge for list-row-v2: the v1 row's tokens plus the one-line fold and evidence icon.
 * DesignTokens → --local-* only; LESS must not reference --wb-*.
 */
export const listRowV2BridgeStyles = {
  'list-row-v2': {
    ...listRowCellBridgeStyles['list-row-cell'],
    // The title never shrinks below this before properties start folding into "+N".
    '--local-list-row-title-floor': '160px',
    // The chevron beside a parent's progress pill that hides or shows its subtasks.
    '--local-list-row-nested-toggle-size': '20px',
    '--local-list-row-nested-toggle-radius': tokens.radius.xs,
    '--local-list-row-nested-toggle-icon-size': tokens.font.size.textXs,
    '--local-list-row-nested-toggle-color': tokens.color.foreground.secondary,
    '--local-list-row-nested-toggle-hover-bg': tokens.color.background.primaryHover,
    '--local-list-row-evidence-size': '20px',
    '--local-list-row-evidence-icon': tokens.color.foreground.secondary,
    '--local-list-row-evidence-badge-size': '10px',
    '--local-list-row-evidence-badge-ring': tokens.color.background.primary,
    '--local-list-row-evidence-success': tokens.color.foreground.successPrimary,
    '--local-list-row-evidence-error': tokens.color.foreground.errorPrimary,
  },
};
